import { render, staticRenderFns } from "./topic-reg-manage-search-bar.vue?vue&type=template&id=320982da"
import script from "./topic-reg-manage-search-bar.vue?vue&type=script&lang=js"
export * from "./topic-reg-manage-search-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports